module.exports = __webpack_public_path__ + "img/appointment_bg.2d233c37.png";